import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "d-flex flex-column gap-4" };
const _hoisted_2 = {
    key: 0,
    class: "card pc-indent"
};
import ProjectDocs from "@/components/uikit/platformComponents/project/ProjectDocs.vue";
import ProjectInvestInfo from "@/components/uikit/platformComponents/project/ProjectInvestInfo.vue";
import ProjectOwnerInfo from "@/components/uikit/platformComponents/project/ProjectOwnerInfo.vue";
import TransactionsHistory from "@/components/uikit/platformComponents/transactions/TransactionsHistory.vue";
import { checkAccess, scope } from "@/help/accessData";
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProjectSubInfo',
    setup(__props) {
        const isTester = computed(() => checkAccess(scope.testRole));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(ProjectOwnerInfo),
                _createVNode(ProjectInvestInfo),
                (isTester.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
                            _createElementVNode("iframe", {
                                width: "100%",
                                height: "640",
                                frameborder: "0",
                                allow: "xr-spatial-tracking; gyroscope; accelerometer",
                                allowfullscreen: "",
                                scrolling: "no",
                                src: "https://kuula.co/share/collection/7D3Lz?logo=1&info=1&fs=1&vr=0&sd=1&thumbs=1"
                            }, null, -1)
                        ]))]))
                    : _createCommentVNode("", true),
                _createVNode(TransactionsHistory),
                _createVNode(ProjectDocs)
            ]));
        };
    }
});
